import { render, staticRenderFns } from "./ProfileGoverningBody.vue?vue&type=template&id=179f1db2&scoped=true"
import script from "./ProfileGoverningBody.vue?vue&type=script&lang=js"
export * from "./ProfileGoverningBody.vue?vue&type=script&lang=js"
import style0 from "./ProfileGoverningBody.vue?vue&type=style&index=0&id=179f1db2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179f1db2",
  null
  
)

export default component.exports